import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { FalsyText } from '@ui-kitten/components/devsupport';
import styled from "../../../theming/util/styled";
import DNAIcon from "../DNAIcon/DNAIcon";
import DNABox from "../../layout/DNABox/DNABox";
import Iffy from "../../util/Iffy/Iffy";
const modifiers = StyleSheet.create({
    roundednone: {
        borderRadius: 0,
    },
    roundedxs: {
        borderRadius: 1,
    },
    roundedsm: {
        borderRadius: 2,
    },
    roundedmd: {
        borderRadius: 4,
    },
    roundedlg: {
        borderRadius: 10,
    },
    roundedxl: {
        borderRadius: 12,
    },
    roundedfull: {
        borderRadius: 1000,
    },
});
export var DNAChipAppearanceEnum;
(function (DNAChipAppearanceEnum) {
    DNAChipAppearanceEnum["tag"] = "tag";
    DNAChipAppearanceEnum["subtle"] = "subtle";
})(DNAChipAppearanceEnum || (DNAChipAppearanceEnum = {}));
export const DNAChipAppearanceKeys = Object.keys(DNAChipAppearanceEnum);
export var DNAChipStatusEnum;
(function (DNAChipStatusEnum) {
    DNAChipStatusEnum["basic"] = "basic";
    DNAChipStatusEnum["primary"] = "primary";
    DNAChipStatusEnum["secondary"] = "secondary";
    DNAChipStatusEnum["info"] = "info";
    DNAChipStatusEnum["success"] = "success";
    DNAChipStatusEnum["warning"] = "warning";
    DNAChipStatusEnum["danger"] = "danger";
})(DNAChipStatusEnum || (DNAChipStatusEnum = {}));
export const DNAChipStatusKeys = Object.keys(DNAChipStatusEnum);
function parseComponentStyle(source) {
    const { textFontSize, textFontWeight, textMarginHorizontal, textMarginVertical, textColor, iconColor, iconHeight, iconWidth, iconName, iconMarginHorizontal, iconMarginVertical, iconMarginRight, ...container } = source;
    return {
        container,
        textStyle: {
            color: textColor,
            fontSize: textFontSize,
            fontWeight: textFontWeight,
            marginHorizontal: textMarginHorizontal,
            marginBottom: textMarginVertical,
        },
        iconStyle: {
            alignSelf: 'center',
            color: iconColor,
            height: iconHeight,
            width: iconWidth,
            marginRight: iconMarginRight,
        },
        iconName,
    };
}
/** [TODO]: Consider re-using as Box? */
const DNAChip = (props) => {
    const { eva, style, rounded, children, onClose, testID, iconLeft } = props;
    const { container, textStyle, iconStyle, iconName } = parseComponentStyle(eva.style);
    const childrenText = children?.toString().toUpperCase() === 'MP4' ? 'VIDEO' : children;
    const roundedStyle = modifiers[`rounded${rounded}`];
    return (<DNABox testID={testID} alignY="center" style={[container, roundedStyle, style]}>
      <Iffy is={onClose}>
        <TouchableOpacity testID="chip-close" onPress={onClose} activeOpacity={1}>
          <DNAIcon name={iconName} style={iconStyle}/>
        </TouchableOpacity>
      </Iffy>
      <Iffy is={iconLeft}>
        <DNAIcon name={iconLeft} style={textStyle}/>
      </Iffy>
      <FalsyText testID="chip-text" style={textStyle} component={childrenText}/>
    </DNABox>);
};
export default styled('DNAChip')(DNAChip);
//# sourceMappingURL=DNAChip.js.map